module.exports = __webpack_public_path__ + "img/a5.4c638ee1.png";